import { combineReducers } from 'redux';

import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';

import actionTypes from './actionTypes';
import shiftSelectors from './selectors';

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_GAME_SHIFTS)(
    actionTypes.GAME_SHIFTS_RESPONSE,
);

const goalsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.GAME_SHIFTS_RESPONSE:
            return shiftSelectors.getGoalData(action.payload.response);
        default:
            return state;
    }
};

const shiftsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.GAME_SHIFTS_RESPONSE:
            return shiftSelectors.getShiftData(action.payload.response);
        default:
            return state;
    }
};

const teamDataReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.TEAM_DATA_RESPONSE:
            return action.payload.response;
        default:
            return state;
    }
};

const gameReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.GAME_RESPONSE:
            return action.payload.response;
        default:
            return state;
    }
};

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    game: gameReducer,
    goals: goalsReducer,
    shifts: shiftsReducer,
    teamData: teamDataReducer,
});

export default reducer;
